import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);

export type TaskCreatedAtDisplayType = {
  relative: string;
  absolute: string;
};

export const getTaskCreatedAtDisplay = (
  createdAt: string,
  now: Date = new Date()
): TaskCreatedAtDisplayType => ({
  relative: dayjs.utc(createdAt).from(dayjs.utc(now)),
  absolute: dayjs.utc(createdAt).tz('Europe/Berlin').format('DD.MM.YYYY HH:mm'),
});
